import { TypedDocumentNode, gql } from '@apollo/client';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  unlockProModeMutation,
  unlockProModeMutationVariables,
} from './__generated__/useEnsureProUnlocked.graphql';

const UNLOCK_PRO_MODE_MUTATION = gql`
  mutation unlockProModeMutation($input: unlockProModeInput!) {
    unlockProMode(input: $input) {
      currentUser {
        slug
        forcedIntoOnboarding
        anyUserSportProfile(sport: FOOTBALL) {
          id
          ... on FootballUserSportProfile {
            id
            proUnlocked
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<unlockProModeMutation, unlockProModeMutationVariables>;

export const useEnsureProUnlocked = () => {
  const { footballUserProfile } = useCurrentUserContext();
  const [searchParams] = useSearchParams();
  const proUnlocked = footballUserProfile?.proUnlocked;
  const [unlockProMode] = useMutation(UNLOCK_PRO_MODE_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  const from = searchParams.get('from');

  useEffect(() => {
    if (!proUnlocked) {
      unlockProMode({
        variables: {
          input: {
            sport: Sport.FOOTBALL,
            interactionContext: from || 'onboarding',
          },
        },
      });
    }
  }, [proUnlocked, unlockProMode, from]);
};
